const c = {
  SUCCESS: "success",
  ERROR: "error",
  DEFAULT: "default",
  WARNING: "warning"
}, e = {
  [c.DEFAULT]: "info",
  [c.WARNING]: "close3",
  [c.SUCCESS]: "checkbox-checked",
  [c.ERROR]: "close3"
};
export {
  e as IconTypeMap,
  c as NotificationType
};
